var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "downArrow",
    clipPath: "url(#clip0_8535_9629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.95981 2.8143C1.11791 2.6562 1.30511 2.57715 1.52139 2.57715C1.73725 2.57715 1.92424 2.6562 2.08234 2.8143L6.71475 7.44671L11.363 2.79849C11.5105 2.65093 11.695 2.57715 11.9163 2.57715C12.1377 2.57715 12.3274 2.6562 12.4855 2.8143C12.6436 2.97241 12.7227 3.1596 12.7227 3.37588C12.7227 3.59175 12.6436 3.77873 12.4855 3.93683L7.15744 9.24909C7.0942 9.31233 7.02569 9.35723 6.95191 9.38379C6.87812 9.40993 6.79907 9.423 6.71475 9.423C6.63043 9.423 6.55138 9.40993 6.4776 9.38379C6.40382 9.35723 6.3353 9.31233 6.27206 9.24909L0.944 3.92102C0.796437 3.77346 0.722656 3.59175 0.722656 3.37588C0.722656 3.1596 0.801707 2.97241 0.95981 2.8143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8535_9629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.722656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowWhite);
export default __webpack_public_path__ + "static/media/downArrow_white.d16a39391c706704231a2b87997a5b34.svg";
export { ForwardRef as ReactComponent };